import { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";

import { RootState } from "../../redux/store";
import { Paths } from "../../common/constants";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { showAlert, getCmsLinks, getAccessToken } from "../../common/utils";
import { getUnReadAnnouncement } from "../../pages/announcements/services/action";

const useHeaderHelper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigationType = useNavigationType();

  const ifProductDetailsRoute = location.pathname.includes(
    Paths.PRODUCT_DETAILS,
  );

  const isUserLoggedIn = getAccessToken() ? true : false;

  const [open, setOpen] = useState<boolean>(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const { isUnreadAnnouncement } = useAppSelector(
    (state: RootState) => state.announcementSlice,
  );

  const isHamburgerVisible =
    location.pathname.includes(Paths.MY_LIBRARY) ||
    location.pathname.includes(Paths.PROFILE);

  const isLoginBtnVisible =
    !isUserLoggedIn &&
    (location.pathname.includes(Paths.MANUFACTURE_DETAILS) ||
      location.pathname.includes(Paths.STRAIN_DETAILS) ||
      location.pathname.includes(Paths.COMPOUND_DETAILS) ||
      location.pathname.includes(Paths.COMPOUND_LISTING) ||
      location.pathname.includes(Paths.REVIEW_LIST) ||
      location.pathname.includes(Paths.BLOCKCHAIN_PRODUCT) ||
      location.pathname.includes(Paths.BLOCKCHAIN_COA_DETAILS));

  const handleBackBtnClick = () => {
    if (location.pathname.includes(Paths.BLOCKCHAIN_PRODUCT)) {
      navigate(-1);
    } else if (
      navigationType === "POP" &&
      location.pathname.includes(Paths.PRODUCT_DETAILS)
    ) {
      if (window.history.length < 3) navigate(Paths.MY_LIBRARY);
      else navigate(-1);
    } else navigate(-1);
  };

  const handleAnnouncementIconClick = () => {
    navigate(Paths.ANNOUNCEMENTS);
  };

  const handleUnderDevelopment = () => {
    showAlert(2, "Under development");
  };

  const handleLoginBtnClick = () => {
    navigate(Paths.SIGNIN);
  };

  useEffect(() => {
    dispatch(getCmsLinks());
    if (
      location.pathname.includes(Paths.MY_LIBRARY) ||
      location.pathname.includes(Paths.PROFILE)
    )
      dispatch(getUnReadAnnouncement());
    //eslint-disable-next-line
  }, []);

  return {
    open,
    isUserLoggedIn,
    isLoginBtnVisible,
    isHamburgerVisible,
    isUnreadAnnouncement,
    ifProductDetailsRoute,

    toggleDrawer,
    handleBackBtnClick,
    handleLoginBtnClick,
    handleUnderDevelopment,
    handleAnnouncementIconClick,
  };
};

export default useHeaderHelper;
